import { useMemo } from "react";
import { useTestMode } from "./useTestMode";
import { usePageData } from "./usePageData";
import { ILiveType } from "../types/ILiveType";

export const useLiveType = () => {
  const { isTestMode } = useTestMode();
  const { domain } = usePageData();

  const liveType = useMemo<ILiveType>(() => {
    switch (true) {
      case domain === "www.sport.pl" || isTestMode:
        return "SPORT";
      default:
        return "UNIVERSAL";
    }
  }, []);

  return {
    liveType,
  };
};
